import * as R from 'ramda';


export default function DeleteServersDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  bcpDataService,
  ssDialogService,
  confirmDialog
) {
  const vm = this;
  
  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleDelete = _handleDelete;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleSelectOne = _handleSelectOne;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteServersDialog);
  }

  function _handleSelectAll() {
    R.forEach((server) => {
      server.isSelected = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.servers);
  }

  function _handleSelectOne() {
    let itemDeleteIsSelected = false;
    
    R.forEach((server) => {
      if (server.isSelected) {
        itemDeleteIsSelected = true;
      }
    }, vm.servers);

    vm.deleteIsSelected = itemDeleteIsSelected
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteServersDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Servers?',
        message: `Are you sure you want to delete the selected Servers?`,
        handleYesClick() {
          _handleConfirmDelete();
        },
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteServersDialog);
  }

  function _handleConfirmDelete(server) {
    const _ids = [];

    R.forEach((server) => {
      if (server.isSelected) {
        _ids.push(server.assessmentServerId);
      }
    }, vm.servers);
  
    const idList = {};
    idList.ids = _ids;

    return bcpDataService.deleteServers(idList).then(() => {
      alerts.success('The selected Server(s) have been deleted successfully.');
      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPServers');
      _closeDeleteDialog();
      _handleCloseDialog();
    })
    .catch(() => {
      alerts.error('An error occurred deleting the selected Server(s).');
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteServersDialog);
  }
}

DeleteServersDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'bcpDataService',
  'ssDialogService',
  'confirmDialog',
];
